import React from 'react';
import { BetslipContext } from '../data/betslip/BetslipConf';
import { ASIAN_HANDICAP } from '../data/constants';
import { getBetDescription } from '../data/utils/getBetDescription';
import { getConfiguration } from '../data/utils/configuration';
import { parseHandicap } from '../data/utils/parseHandicap';

function OddWrapper(props) {
    const conf = getConfiguration();
    
    const betslipContext = React.useContext(BetslipContext);

    const betData = props.betData;
    const betId = betData.cs != null ? props.betData.cs : props.betData.id;

    function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        let hcp = props.betData.handicap;
        if (conf.nas && ASIAN_HANDICAP.includes(props.betData.id) && props.id === 2) {
            hcp *= -1;
        }
    	let betDesc = props.betData.desc;
        let oddDesc = props.desc;
        if (props.betData.hideHandicap === true) {
            betDesc = props.betData.aggDesc;
            oddDesc = `${betData.desc} ${props.desc}`;
        }
        else{
            betDesc = getBetDescription(betData, false, props.matchData.sportRef);
        } 
        /*else if (props.betData.handicap !== 0) {
            let draws = null;
            if (props.betData.tipoHandicap === 7) {
                draws = props.betData.eqs;
            }
            betDesc = parseHandicap(props.betData.desc, hcp, props.betData.tipoHandicap, draws, props.betData.dia);
        }*/
        const timestamp = props.matchData.timestampDB? props.matchData.timestampDB : props.matchData.timestamp;
    	props.value != null && 
        betslipContext.toggleSelectionBetslip(props.matchData.pal,
                                                props.matchData.avv,
                                                props.matchData.alias,
                                                props.matchData.desc,
                                                props.betData.isLive,
                                                betId,
                                                props.betData.handicap,
                                                betDesc,
                                                props.id,
                                                oddDesc,
                                                props.rawValue,
                                                props.betData.legabile,
                                                props.matchData.sportDesc,
                                                props.matchData.tournamentDesc,
                                                timestamp,
                                                props.matchData.sportRef,
                                                props.matchData.tournamentRef,
                                                props.betData.ming,
                                                props.betData.maxg);
    }

    const selected = betslipContext.isDrawSelected(props.matchData.pal, props.matchData.avv, props.betData.id, props.betData.handicap, props.id);

    return (
        <>
            {props.render({...props, selected, onClick})}
        </>
    );
}

export default OddWrapper;